import { useState, useEffect } from "react";

export function useHasScrolled(threshold = 10): boolean {
  const [hasScrolled, setHasScrolled] = useState(
    () => window.scrollY > threshold
  );

  useEffect(() => {
    const onScroll = () => {
      setHasScrolled(window.scrollY > threshold);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return hasScrolled;
}
